module.exports = __webpack_public_path__ + "img/logo.c8cd1f17.png";